"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackType = void 0;
var types_1 = require("./matroska/types");
Object.defineProperty(exports, "TrackType", { enumerable: true, get: function () { return types_1.TrackType; } });
//# sourceMappingURL=type.js.map